import React from 'react'
import styled from 'styled-components'
import Icon, { IconType } from '../../../system/icons'
import { FaGlobe } from 'react-icons/fa'
import { useEvent } from '../../event-details'
import { getTwitterLink, getFacebookLink, getInstagramLink } from './social-links'

const Social = styled.li`
  &:not(:first-of-type) {
    margin-top: ${props => props.theme.spacing.base200};
  }

  a {
    display: flex;
    align-items: center;

    span {
      margin-left: ${props => props.theme.spacing.base200};
    }
  }
`

const OrganizerSocial = () => {
  const event = useEvent()
  if (!event) return null
  const organizer = event.organizer

  return (
    <ul>
      {organizer.website && (
        <Social>
          <a
            href={organizer.website}
            target="_blank"
            rel="noopener"
            aria-label="Organizer's Website"
          >
            <FaGlobe size={20} aria-hidden="true" />
            <span>{organizer.websiteLabel || 'Website'}</span>
          </a>
        </Social>
      )}

      {organizer.twitter && (
        <Social>
          <a
            href={getTwitterLink(organizer.twitter)}
            target="_blank"
            rel="noopener"
            aria-label={`Organizer's Twitter - ${organizer.twitter}`}
          >
            <Icon type={IconType.Twitter} aria-hidden="true" />
            <span>{organizer.twitter}</span>
          </a>
        </Social>
      )}

      {organizer.facebook && (
        <Social>
          <a
            href={getFacebookLink(organizer.facebook)}
            target="_blank"
            rel="noopener"
            aria-label={`Organizer's Facebook - ${organizer.facebookLabel || organizer.facebook}`}
          >
            <Icon type={IconType.Facebook} aria-hidden="true" />
            <span>{organizer.facebookLabel || organizer.facebook}</span>
          </a>
        </Social>
      )}

      {organizer.instagram && (
        <Social>
          <a
            href={getInstagramLink(organizer.instagram)}
            target="_blank"
            rel="noopener"
            aria-label={`Organizer's Instagram - ${organizer.instagram}`}
          >
            <Icon type={IconType.Instagram} aria-hidden="true" />
            <span>{organizer.instagram}</span>
          </a>
        </Social>
      )}
    </ul>
  )
}

export default OrganizerSocial
